<template>
  <v-container
    salidas-container
    fluid
    grid-list-md
    text-xs-center
    style="min-height: 93.4vh"
  >
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="z-index: 1">
        <v-toolbar-title>{{ $t('visor.check_out') }}</v-toolbar-title>
        <v-speed-dial
          v-if="permits['WATCH_VISOR'] && permits['START_VISOR']"
          :key="activeFab.id"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="tabButton"
                  v-model="buttonFab.fab"
                  :color="activeFab.color"
                  style="z-index: 99"
                  dark
                  fab
                  small
                  v-on="on"
                >
                  <v-icon>{{ activeFab.icon }}</v-icon>
                  <v-icon>{{ activeFab.clear }}</v-icon>
                </v-btn>
              </template>
              <span>{{ activeFab.tooltip }}</span>
            </v-tooltip>
          </template>
          <v-tooltip right v-show="activeFab.id == 1">
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="modals.eGroups = true"
            >
              <v-icon>people</v-icon>
            </v-btn>
            <span>{{ $t('visor.edit_groups') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="white"
              slot="activator"
              @click="modals.thirdQr = true"
            >
              <v-avatar size="40px">
                <img :src="require('@/assets/qr/SKLB-QR.png')" alt="alt" />
              </v-avatar>
            </v-btn>
            <span>{{ $t('visor.qr_assets_of_the_day') }}</span>
          </v-tooltip>
        </v-speed-dial>
        <v-spacer></v-spacer>
        <v-layout v-if="!flags.started" row wrap justify-center>
          <v-flex xs12 sm5 md5>
            <v-text-field
              min="0"
              v-model="settings.time"
              :label="$t('visor.notification_interval')"
              type="number"
              suffix="segundos"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap justify-center>
          <v-flex xs12 class="titleSearch">
            <v-text-field
              class="mx-3"
              flat
              :label="$t('visor.search')"
              prepend-inner-icon="search"
              v-model="search"
              solo-inverted
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-spacer v-if="!flags.started"></v-spacer>
        <v-layout v-if="!flags.started" row wrap justify-center>
          <v-flex xs10 sm5 md5>
            <v-select
              :items="sounds"
              item-text="name"
              item-value="url"
              v-model="settings.sound"
              :label="$t('visor.notification_sound')"
            ></v-select>
          </v-flex>
          <v-flex xs2 sm1 md1>
            <v-btn icon @click="playSound">
              <v-icon color="secondary">play_arrow</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn icon @click="settings.mute = !settings.mute">
          <v-icon v-if="settings.mute" color="primary">volume_off</v-icon>
          <v-icon v-else color="secondary">volume_up</v-icon>
        </v-btn>
        <v-btn
          dark
          fab
          small
          v-if="flags.started && flags.disconnect"
          color="orange"
        >
          <v-icon>warning</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar v-show="barCount" class="groups-bar">
        <span style="font-weight: bold; padding-right: 10px">
          {{ $t('visor.groups') }}:
        </span>
        {{ groupsNames }}
        <v-tooltip
          v-model="openSeeMoreGroups"
          :open-on-click="true"
          bottom
          v-if="selected.ggs.length > maxGroupsInList"
        >
          <template slot="activator"
            >...
            <a @click="openSeeMoreGroups = !openSeeMoreGroups">
              [{{ selected.ggs.length - maxGroupsInList }}
              {{ $t('visor.more_groups') }}]
            </a>
          </template>
          <ul class="more-groups-list">
            <li v-for="g in seeMoreGroups" :key="g">{{ g }}</li>
          </ul>
        </v-tooltip>
      </v-toolbar>
      <v-toolbar v-show="barCount" align-center :class="'tags-toolbar'">
        <v-container
          entregas-total-tags
          text-xs-center
          :class="{
            'is-column':
              $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly,
            'very-small': $vuetify.breakpoint.xsOnly,
          }"
        >
          <v-layout>
            <v-flex xs4>
              <v-img class="total">
                <p>{{ this.count.total }}</p>
              </v-img>
              <p class="tag-label">{{ $t('visor.total_students') }}</p>
            </v-flex>
            <v-flex
              xs4
              solicitados
              :class="{
                active: mobileSelectedPage == 0,
                interactive: $vuetify.breakpoint.xsOnly,
              }"
              @click="navSlider(0)"
            >
              <v-img>
                <p>{{ this.transaction.transactions1.length }}</p>
              </v-img>
              <p class="tag-label">{{ $t('visor.requested') }}</p>
            </v-flex>
            <v-flex
              xs4
              camino
              :class="{
                active: mobileSelectedPage == 1,
                interactive: $vuetify.breakpoint.xsOnly,
              }"
              @click="navSlider(1)"
            >
              <v-img>
                <p>{{ this.transaction.transactions3.length }}</p>
              </v-img>
              <p class="tag-label">{{ $t('visor.on_the_way') }}</p>
            </v-flex>
            <v-flex xs4>
              <v-img class="entrega">
                <p>{{ this.count.delivery }}</p>
              </v-img>
              <p class="tag-label">{{ $t('visor.delivered') }}</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-toolbar>
      <v-container fluid elevation-2>
        <v-layout row wrap>
          <v-slide-y-transition mode="out-in">
            <v-flex xs6 offset-xs3 v-if="!flags.started" :key="0">
              <svg
                id="startBtn"
                @click="tabButton"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 432 102.5"
              >
                <g id="Capa_2" data-name="Capa 2">
                  <g id="Capa_1-2" data-name="Capa 1">
                    <rect class="cls-1" width="432" height="102.5" rx="51.25" />
                    <text class="cls-2" transform="translate(118.11 67.57)">
                      {{ $t('visor.start_dismissal') }}
                    </text>
                    <circle class="cls-3" cx="50.5" cy="51.75" r="32.5" />
                    <path
                      class="cls-1"
                      d="M24.13,51.75A26.37,26.37,0,1,0,50.5,25.38,26.36,26.36,0,0,0,24.13,51.75Zm47.63,0A21.26,21.26,0,1,1,50.5,30.49,21.25,21.25,0,0,1,71.76,51.75Zm-33.59,3.4H50.5v7.13a1.28,1.28,0,0,0,2.18.9L63.21,52.65a1.27,1.27,0,0,0,0-1.8L52.68,40.32a1.28,1.28,0,0,0-2.18.9v7.13H38.17a1.27,1.27,0,0,0-1.28,1.27v4.26A1.27,1.27,0,0,0,38.17,55.15Z"
                    />
                  </g>
                </g>
              </svg>
              <v-img
                style="opacity: 0.25"
                :src="require('@/assets/panel/home/SKLB-Entregas.png')"
              ></v-img>
            </v-flex>
            <v-flex xs12 v-if="flags.started" :key="1">
              <v-layout row wrap justify-center>
                <v-flex xs12 v-if="$vuetify.breakpoint.xsOnly">
                  <v-carousel
                    :cycle="false"
                    v-model="mobileSelectedPage"
                    hide-delimiters
                    light
                    hide-controls
                    class="elevation-0"
                  >
                    <v-carousel-item>
                      <listScroller
                        ref="mobSolicitadosList"
                        :list="searchStudent1"
                        :permits="permits"
                        @unDo="undoSend($event)"
                        @send="send($event)"
                      ></listScroller>
                    </v-carousel-item>
                    <v-carousel-item>
                      <listScroller
                        ref="mobCaminoList"
                        :list="searchStudent3"
                        :permits="permits"
                        @unDo="undoSend($event)"
                        @send="send($event)"
                      ></listScroller>
                    </v-carousel-item>
                  </v-carousel>
                </v-flex>
                <template v-else>
                  <v-flex sm6 lg5 xl4>
                    <listScroller
                      :list="searchStudent1"
                      :permits="permits"
                      @unDo="undoSend($event)"
                      @send="send($event)"
                    ></listScroller>
                  </v-flex>
                  <v-flex sm6 lg5 xl4>
                    <listScroller
                      :list="searchStudent3"
                      :permits="permits"
                      @unDo="undoSend($event)"
                      @send="send($event)"
                    ></listScroller>
                  </v-flex>
                </template>
              </v-layout>
            </v-flex>
          </v-slide-y-transition>
        </v-layout>
      </v-container>
    </v-layout>
    <ThirQr v-model="modals.thirdQr"></ThirQr>
    <selectGroups
      :selectedGG="selected.ggs"
      :startFlag="flags.started"
      v-model="modals.eGroups"
      v-on:init="start"
    ></selectGroups>
    <notification
      v-model="modals.notification"
      :transaction="selected.transaction"
      v-on:closed="changeStudentNotification"
      :settings="settings"
    ></notification>
    <loading v-model="working.wLoading" :text="toast.lmessage"></loading>
    <success v-model="toast.success" :text="toast.message"></success>
    <error
      v-model="toast.failed"
      :text="toast.eMessage"
      :fixed="flags.fixedFlag"
    ></error>
    <warning v-model="toast.warning" :text="toast.wMessage"></warning>
  </v-container>
</template>

<script>
import moment from 'moment'
import { clearInterval, clearTimeout, setInterval, setTimeout } from 'timers'
import { mapGetters } from 'vuex'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import notification from '../../Dialogs/Notification'
import success from '../../Dialogs/Success'
import warning from '../../Dialogs/warning'
import selectGroups from '../../Modals/SelectGroupsVisor'
import ThirQr from '../../Modals/ThirdQr'
import listScroller from '../../Sections/Visor/ListScroller'
export default {
  components: {
    selectGroups,
    notification,
    loading,
    error,
    success,
    ThirQr,
    warning,
    listScroller,
  },
  data: () => ({
    mobileSelectedPage: 0,
    openSeeMoreGroups: false,
    settings: {
      time: 5,
      mute: false,
      sound: 'assets/sounds/not1.mp3',
    },
    sounds: [
      { name: 'Sonido 1', url: 'assets/sounds/not1.mp3' },
      { name: 'Sonido 2', url: 'assets/sounds/not2.mp3' },
      { name: 'Sonido 3', url: 'assets/sounds/not3.mp3' },
      { name: 'Sonido 4', url: 'assets/sounds/not4.mp3' },
      { name: 'Sonido 5', url: 'assets/sounds/not5.mp3' },
      { name: 'Sonido 6', url: 'assets/sounds/not6.mp3' },
      { name: 'Sonido 7', url: 'assets/sounds/not7.mp3' },
      { name: 'Sonido 8', url: 'assets/sounds/not8.mp3' },
      { name: 'Sonido 9', url: 'assets/sounds/not9.mp3' },
      { name: 'Sonido 10', url: 'assets/sounds/not10.mp3' },
      { name: 'Sonido 11', url: 'assets/sounds/not11.mp3' },
    ],
    working: {
      wLoading: false,
      wGroups: false,
      send: false,
    },
    toast: {
      success: false,
      failed: false,
      message: '',
      lmessage: '',
      emMessage: '',
      wMessage: '',
      alert: false,
      warning: false,
    },
    transaction: {
      transactions1: [],
      transactions3: [],
    },
    count: {
      total: '',
      delivery: '',
      resq: '',
      camino: '',
    },
    barCount: false,
    buttonFab: {
      fab: false,
      hidden: false,
    },
    flags: {
      started: false,
      interval: false,
      eventListener: false,
      fixedFlag: false,
      disconnect: false,
    },
    modals: {
      eGroups: false,
      notification: false,
      thirdQr: false,
    },
    selected: {
      ggs: [],
      transaction: {
        student: {
          imageStorage: {},
        },
        door: {},
      },
      transactionsPool: [],
    },
    permits: [],
    socket: null,
    search: '',
  }),
  sockets: {
    connect(evt) {
      console.log('Connected', evt)
      this.toast.warning = false
    },
    disconnect(evt) {
      console.log('Disconnected', evt)
      if (evt == 'transport error') {
        this.flags.disconnect = true
        this.toast.wMessage =
          'Al parecer la conexiónse interrumpió. Intenta recargar la página y/o revisa tu conexión a internet'
        this.toast.warning = true
      }
    },
    reconnect() {
      console.log('Reconnecting')
      this.getGroups()
      this.subscribe(this.selected.ggs)
      this.flags.disconnect = false
    },
    message(notification) {
      var not = {
        data: {
          notification: JSON.stringify(notification),
        },
      }
      console.log('MESSAGE', notification)
      this.handler(not)
    },
  },
  filters: {
    momentFormat(value) {
      if (value != null) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      }
      return ''
    },
  },
  mounted() {
    if (this.getUser.id) this.mapPermits()
    if (this.permits['WATCH_VISOR']) this.isEnable()
    this.flags.fixedFlag = false
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  watch: {
    mobileSelectedPage() {
      if (this.$refs.mobSolicitadosList)
        this.$refs.mobSolicitadosList.hideAllToolTips()

      if (this.$refs.mobCaminoList) this.$refs.mobCaminoList.hideAllToolTips()
    },
    getUser() {
      this.mapPermits()
      if (this.permits['WATCH_VISOR']) this.isEnable()
    },
  },
  methods: {
    navSlider(i) {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.mobileSelectedPage = i
      }
    },
    playSound() {
      var sound = new Audio(require('@/' + this.settings.sound))
      sound.play()
    },
    getRoomID(g) {
      let room = g.levelId + '-' + g.grade + '' + g.group + '-' + g.id
      // console.log("ROOM ID -> ", room);
      return room
    },
    mapPermits() {
      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (catalogs[c].name.includes('VISOR')) {
          this.permits[catalogs[c].name] = 1
        }
      }
      this.$forceUpdate()
    },
    isEnable() {
      this.$store
        .dispatch('request/isEnableWeb')
        .then((response) => {
          if (response.data.code == 203) {
            this.start(response.data.entity)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    tabButton() {
      if (!this.flags.started) {
        this.modals.eGroups = true
      } else {
        this.stop()
        this.flags.started = false
      }
    },
    undoSend(item) {
      item.loading = false
      item.uLoading = false
      item.undo = false
      item.begun = false
      item.progressValue = 5
      clearTimeout(item.timeout)
      clearInterval(item.interval)
      this.$forceUpdate()
    },
    send(item) {
      if (item.status != 'C') {
        this.$set(item, 'loading', true)
        this.$set(item, 'progressValue', 5)
        var v = this
        item.interval = setInterval(() => {
          if (item.progressValue != 0) {
            item.progressValue--
          } else {
            clearInterval(item.interval)
          }
        }, 1000)
        item.timeout = setTimeout(() => {
          if (!item.undo) {
            clearInterval(item.interval)
            item.begun = true
            v.$store
              .dispatch('request/send', item.id)
              .then(() => {
                item.loading = false
                item.status = 'C'
                item.loading = false
                item.uLoading = false
                item.undo = false
                item.begun = false
              })
              .catch((error) => {
                item.loading = false
                v.toast.eMessage = 'No se pudo enviar, inténtelo más tarde '
                v.toast.failed = true
                item.loading = false
                item.uLoading = false
                item.undo = false
                item.begun = false
                console.log(error)
              })
          } else {
            item.loading = false
            item.uLoading = false
            item.undo = false
            item.begun = false
          }
        }, 5000)
      }
    },
    unsubscribe() {
      if (this.selected.ggs && this.selected.ggs.length > 0) {
        // console.log("Unsubscribing from " + this.selected.ggs.length + " groups");
        for (let group of this.selected.ggs) {
          var roomID = this.getRoomID(group)
          // console.log("Unsubscribing from", roomID);
          this.$socket.emit('unsubscribe', roomID)
        }
      } else {
        // console.log("No groups to disconnect from...");
      }
    },
    subscribe(groups) {
      this.unsubscribe()
      if (groups) {
        // console.log("Setting up rooms");
        for (let group of groups) {
          var roomID = this.getRoomID(group)
          // console.log("Subscribing from", roomID);
          this.$socket.emit('subscribe', roomID)
        }
      } else {
        // console.log("No groups to subscribe");
      }

      // console.log(54, structuredClone(groups));
      this.selected.ggs = groups
    },
    async start(event) {
      this.working.wGroups = true
      this.working.wLoading = true
      this.toast.failed = false

      if (this.flags.started) {
        this.toast.lmessage = `${this.$t('visor.updating_groups')}`
        this.subscribe(event)
        this.sendGroupsToServer({
          groups: event,
        })
      } else {
        this.flags.fixedFlag = false
        this.toast.lmessage = `${this.$t('visor.starting_dismissal')}`

        this.$socket.connect()
        this.subscribe(event)

        this.flags.started = true
        if (event === null) {
          this.getGroups()
        } else {
          GoogleAnalytics.actionEvent({
            eventName: 'started_outings',
            eventDescription: 'Inicio de salidas',
          })
          this.sendGroupsToServer({
            groups: event,
          })
        }
      }
    },
    getGroups() {
      this.$store
        .dispatch('request/getGroups')
        .then((response) => {
          this.transaction.transactions1 = []
          this.transaction.transactions3 = []
          this.working.wLoading = false
          this.toast.success = true
          this.toast.message = `${this.$t('visor.dismissal_has_begun')}`
          var v = this

          /*
          const someCards = [
        {
            "id": 434067,
            "student": {
                "id": 54943,
                "transId": 0,
                "firstName": "César",
                "lastName": "Jiménez",
                "registered": false,
                "image": "",
                "actionflag": false,
                "sendFlag": false
            },
            "door": {
                "id": 197,
                "longitude": -101.11512756820679,
                "latitude": 19.703793207769984,
                "street": "Av.Tres Marías",
                "type": "M",
                "doorName": "Puerta Norte",
                "enable": true,
                "distanceSetting": 3000
            },
            "car": {
                "id": 17636,
                "brand": "null",
                "model": "Nissan",
                "plates": "TEST1234",
                "color": "Azul acero",
                "available": true
            },
            "requestedTime": 1633564332000,
            "requestedDate": 1633478400000,
            "day": 1633564332000,
            "accuracy": 0.0,
            "accurate": false,
            "status": "R",
            "numChanges": 0,
            "nStudents": 0,
            "confirm": false,
            "typeSendLocation": true,
            "typeReq": "PAR",
            "personRequesting": "Roxana Jiménez"
        },
        {
            "id": 434068,
            "student": {
                "id": 61844,
                "transId": 0,
                "firstName": "Fernanda",
                "lastName": "Jiménez",
                "registered": false,
                "image": "",
                "actionflag": false,
                "sendFlag": false
            },
            "door": {
                "id": 197,
                "longitude": -101.11512756820679,
                "latitude": 19.703793207769984,
                "street": "Av.Tres Marías",
                "type": "M",
                "doorName": "Puerta Norte",
                "enable": true,
                "distanceSetting": 3000
            },
            "car": {
                "id": 17636,
                "brand": "null",
                "model": "Nissan",
                "plates": "TEST1234",
                "color": "Azul acero",
                "available": true
            },
            "requestedTime": 1633564343000,
            "requestedDate": 1633478400000,
            "day": 1633564343000,
            "accuracy": 0.0,
            "accurate": false,
            "status": "C",
            "numChanges": 1,
            "nStudents": 0,
            "confirm": false,
            "typeSendLocation": true,
            "typeReq": "PAR",
            "personRequesting": "Roxana Jiménez"
        },
        {
            "id": 434069,
            "student": {
                "id": 56473,
                "transId": 0,
                "firstName": "Francisco",
                "lastName": "Olivares",
                "registered": false,
                "image": "",
                "actionflag": false,
                "sendFlag": false,
                "imageStorage": {
                    "id": 0,
                    "miniObjUrl": "https://prod-skolable.s3.us-west-2.amazonaws.com/1035/Children/Thumbnails/thumb56473.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20211006T154009Z&X-Amz-SignedHeaders=host&X-Amz-Expires=521999&X-Amz-Credential=AKIAIKE3FJTWSYQBRFAA%2F20211006%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Signature=1c6071ba462e00a700fdaa265724246e82ca90bf5bea3cd0a68dee6bc8f774e1"
                }
            },
            "door": {
                "id": 197,
                "longitude": -101.11512756820679,
                "latitude": 19.703793207769984,
                "street": "Av.Tres Marías",
                "type": "M",
                "doorName": "Puerta Norte",
                "enable": true,
                "distanceSetting": 3000
            },
            "requestedTime": 1633564354000,
            "requestedDate": 1633478400000,
            "day": 1633564354000,
            "accuracy": 0.0,
            "accurate": false,
            "status": "R",
            "numChanges": 0,
            "nStudents": 0,
            "confirm": false,
            "typeSendLocation": true,
            "typeReq": "PAR",
            "personRequesting": "Roxana Jiménez"
        },
        {
            "id": 434070,
            "student": {
                "id": 61845,
                "transId": 0,
                "firstName": "Karla",
                "lastName": "Olivares",
                "registered": false,
                "image": "",
                "actionflag": false,
                "sendFlag": false
            },
            "door": {
                "id": 197,
                "longitude": -101.11512756820679,
                "latitude": 19.703793207769984,
                "street": "Av.Tres Marías",
                "type": "M",
                "doorName": "Puerta Norte",
                "enable": true,
                "distanceSetting": 3000
            },
            "car": {
                "id": 99,
                "brand": "Taxi",
                "model": "Taxi",
                "plates": "Taxi",
                "color": "Taxi",
                "available": true
            },
            "requestedTime": 1633564367000,
            "requestedDate": 1633478400000,
            "day": 1633564367000,
            "accuracy": 0.0,
            "accurate": false,
            "status": "C",
            "numChanges": 1,
            "nStudents": 0,
            "confirm": false,
            "typeSendLocation": true,
            "typeReq": "PAR",
            "personRequesting": "Roxana Jiménez"
        },
        {
            "id": 434071,
            "student": {
                "id": 61843,
                "transId": 0,
                "firstName": "Luis",
                "lastName": "Olivares",
                "registered": false,
                "image": "",
                "actionflag": false,
                "sendFlag": false
            },
            "door": {
                "id": 197,
                "longitude": -101.11512756820679,
                "latitude": 19.703793207769984,
                "street": "Av.Tres Marías",
                "type": "M",
                "doorName": "Puerta Norte",
                "enable": true,
                "distanceSetting": 3000
            },
            "car": {
                "id": 17636,
                "brand": "null",
                "model": "Nissan",
                "plates": "TEST1234",
                "color": "Azul acero",
                "available": true
            },
            "requestedTime": 1633564379000,
            "requestedDate": 1633478400000,
            "day": 1633564379000,
            "accuracy": 0.0,
            "accurate": false,
            "status": "R",
            "numChanges": 0,
            "nStudents": 0,
            "confirm": false,
            "typeSendLocation": true,
            "typeReq": "PAR",
            "personRequesting": "Roxana Jiménez"
        },
        {
            "id": 434072,
            "student": {
                "id": 61842,
                "transId": 0,
                "firstName": "Paola",
                "lastName": "Olivares",
                "registered": false,
                "image": "",
                "actionflag": false,
                "sendFlag": false
            },
            "door": {
                "id": 197,
                "longitude": -101.11512756820679,
                "latitude": 19.703793207769984,
                "street": "Av.Tres Marías",
                "type": "M",
                "doorName": "Puerta Norte",
                "enable": true,
                "distanceSetting": 3000
            },
            "requestedTime": 1633564389000,
            "requestedDate": 1633478400000,
            "day": 1633564389000,
            "accuracy": 0.0,
            "accurate": false,
            "status": "C",
            "numChanges": 1,
            "nStudents": 0,
            "confirm": false,
            "typeSendLocation": true,
            "typeReq": "PAR",
            "personRequesting": "Roxana Jiménez"
        }
    ];

        const maxElems = 200;
        response.data.entity = [];
        for (let i = 0; i <= maxElems; i++) {
          const card = someCards[Math.round(Math.random()*(someCards.length-1))];
          const clone = JSON.parse(JSON.stringify(card));
          clone.id = Math.round(Math.random()*100000);
          response.data.entity.push(clone);
        }
        */

          for (let t of response.data.entity) {
            let alreadyInArray = false
            t.loading = false
            if (t.status == 'C') {
              alreadyInArray = this.transaction.transactions3.some(
                (ct) => ct.id === t.id
              )

              if (!alreadyInArray) {
                this.transaction.transactions3.push(t)
              }
            } else {
              alreadyInArray = this.transaction.transactions1.some(
                (ct) => ct.id === t.id
              )

              if (!alreadyInArray) {
                v.transaction.transactions1.push(t)
              }
            }
          }
          this.working.wGroups = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    stop() {
      this.working.wLoading = true
      this.toast.lmessage = `${this.$t('visor.dismissal_time_is_ending')}`
      this.barCount = false
      this.count.total = ''
      this.count.delivery = ''
      this.count.resq = ''
      this.count.camino = ''
      this.$socket.disconnect()
      this.unsubscribe()

      this.$store
        .dispatch('request/stopVisor')
        .then(() => {
          this.flags.started = false
          this.working.wLoading = false
          this.toast.success = true
          this.toast.message = `${this.$t('visor.dismissal_time_has_ended')}`
          this.transaction.transactions1 = []
          this.transaction.transactions3 = []
          this.selected.ggs = []
          this.selected.transactionsPool = []
        })
        .catch((error) => {
          console.log(error)
        })
    },
    sendTokenToServer(token, obj) {
      this.$store
        .dispatch('request/sendTokenToServer', obj)
        .then(() => {
          this.getGroups()
          this.flags.started = true
          this.modals.eGroups = false
          this.working.wLoading = false
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          this.toast.eMessage = `${this.$t('visor.something_went_wrong')} ${
            error.code
          }`
          console.log(error)
        })
    },
    sendGroupsToServer(obj) {
      this.$store
        .dispatch('request/sendGroups', obj)
        .then((response) => {
          this.modals.eGroups = false
          this.working.wLoading = false
          this.toast.success = true
          this.toast.message = `${this.$t('visor.updated_groups')}`
          this.barCount = true
          this.count.total = response.data.entity.totalCount
          this.count.delivery = response.data.entity.deliveredCount
          this.count.resq = response.data.entity.requestedCount
          this.count.camino = response.data.entity.calledCount
          this.getGroups()
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          this.toast.eMessage = `${this.$t('visor.something_went_wrong')} ${
            error.code
          }`
          console.log(error)
        })
    },
    changeStudentNotification() {
      this.modals.notification = false
      setTimeout(() => {
        var transaction = this.selected.transactionsPool.splice(0, 1)[0]

        let flag = false
        for (let t in this.transaction.transactions1) {
          if (
            this.transaction.transactions1[t] != null &&
            this.transaction.transactions1[t].id == transaction.id
          ) {
            flag = true
          }
        }

        if (!flag) {
          this.transaction.transactions1.push(transaction)
        }

        if (this.selected.transactionsPool.length > 0) {
          for (let [i, t] of this.selected.transactionsPool.entries()) {
            if (transaction.id != t.id) {
              this.selected.transaction = this.selected.transactionsPool[0]
              this.modals.notification = true
              break
            }
            this.selected.transactionsPool.splice(i, 1)
            if (this.selected.transactionsPool.length == 0)
              this.flags.interval = false
          }
        } else {
          this.flags.interval = false
        }
      }, 500)
    },
    removeFromQueue(transaction, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == transaction.id) {
          arr.splice(i, 1)
          return true
        }
      }
      return false
    },
    changeQueue(transaction, sourceArr, destinationArr) {
      let index = sourceArr.findIndex(function (el) {
        return el.id === transaction.id
      })

      if (index < 0) {
        return false
      }

      let el = sourceArr.splice(index, 1)[0]
      let indexD = destinationArr.findIndex(function (el) {
        return el.id === transaction.id
      })

      if (indexD < 0) {
        el.status = transaction.status
        destinationArr.unshift(el)
      } else {
        destinationArr[indexD].status = transaction.status
      }
      return true
    },
    changeDoor(transaction, arr) {
      let index = arr.findIndex(function (el) {
        return el.id === transaction.id
      })

      if (index < 0) {
        return false
      }

      arr[index].status = transaction.status
      arr[index].door.id = transaction.door.id
      arr[index].door.doorName = transaction.door.doorName
      return true
    },
    handler(notification) {
      if (this.working.wGroups) {
        var vm = this
        setTimeout(() => {
          vm.handler(notification)
        }, 1000)
      } else {
        let transaction = JSON.parse(notification.data.notification)
        var flag = false
        if (transaction.status == 'U' && transaction.student.status == 'Q') {
          transaction.status = 'X'
        }
        transaction.loading = false

        switch (transaction.status) {
          case 'D':
            flag = this.removeFromQueue(
              transaction,
              this.transaction.transactions1
            )
            this.removeFromQueue(transaction, this.transaction.transactions3)
            this.count.delivery = this.count.delivery + 1
            this.count.camino = this.transaction.transactions3.length
            console.log(
              'Transaction removed because D',
              transaction.id,
              flag,
              this.selected.transactionsPool
            )
            break
          case 'C':
            if (!this.selected.transactionsPool.includes(transaction)) {
              this.selected.transactionsPool.push(transaction)
              flag = this.changeQueue(
                transaction,
                this.selected.transactionsPool,
                this.transaction.transactions3
              )
              // this.count.camino = this.transaction.transactions3.length;
            }
            flag =
              this.changeQueue(
                transaction,
                this.transaction.transactions1,
                this.transaction.transactions3
              ) ||
              this.changeQueue(
                transaction,
                this.selected.transactionsPool,
                this.transaction.transactions3
              )

            this.count.camino = this.transaction.transactions3.length
            this.count.resq = this.transaction.transactions1.length
            console.log(
              'Transaction mov because C',
              this.selected.transaction,
              this.selected.transactionsPool
            )

            break
          case 'X':
            flag =
              this.removeFromQueue(
                transaction,
                this.transaction.transactions1
              ) ||
              this.removeFromQueue(transaction, this.transaction.transactions3)
            this.count.resq = this.transaction.transactions1.length
            this.count.camino = this.transaction.transactions3.length
            console.log('Transaction removed because X', transaction.id, flag)
            break
          case 'R':
            flag = this.removeFromQueue(
              transaction,
              this.transaction.transactions3
            )
            this.count.camino = this.transaction.transactions3.length
            console.log('Transaction removed because R', transaction.id, flag)

            if (!this.selected.transactionsPool.includes(transaction)) {
              this.selected.transactionsPool.push(transaction)
              this.count.resq = this.transaction.transactions1.length

              if (!this.flags.interval) {
                this.selected.transaction = this.selected.transactionsPool[0]
                this.modals.notification = true
                this.flags.interval = true
              }
            }
            console.log('transaction status', this.transaction)
            break

          case 'U':
            if (
              transaction.status === 'U' &&
              transaction.student.status === 'R'
            ) {
              transaction.status = 'R'
            }

            flag =
              this.changeDoor(transaction, this.transaction.transactions1) ||
              this.changeDoor(transaction, this.transaction.transactions3)
            console.log(
              'Transaction updated (door) because U',
              transaction.id,
              flag
            )

            if (flag == false) {
              this.handler({
                data: { notification: JSON.stringify(transaction) },
              })
            }
            break
        }
      }
    },
    getStudentImage(transaction) {
      if (transaction != null) {
        this.$store
          .dispatch('student/getImage', transaction.student.id)
          .then((response) => {
            if (response.data.entity.image != '') {
              if (this.transaction.transactions1.includes(transaction)) {
                let i = this.transaction.transactions1.indexOf(transaction)
                this.transaction.transactions1[i].img =
                  'data:image/jpg;base64, ' + response.data.entity.image
              } else if (this.transaction.transactions3.includes(transaction)) {
                let i = this.transaction.transactions3.indexOf(transaction)
                this.transaction.transactions3[i].img =
                  'data:image/jpg;base64, ' + response.data.entity.image
              }
              this.$forceUpdate()
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    onCancel() {
      this.modals.eGroups = false
      this.modals.thirdQr = false
      ;(this.modals.notification = false), this.$forceUpdate()
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    concatGradeGroup(g) {
      if (g && g.grade && g.group) {
        let sep = g.grade.length == 1 && g.group.length == 1 ? '' : ' '
        return g.grade + sep + g.group
      }
      return ''
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    groupsNames() {
      return this.selected.ggs
        .map(this.concatGradeGroup)
        .slice(0, this.maxGroupsInList)
        .join(', ')
        .trim()
    },
    seeMoreGroups() {
      if (this.selected.ggs.length > this.maxGroupsInList) {
        return this.selected.ggs
          .map(this.concatGradeGroup)
          .slice(this.maxGroupsInList)
      }
      return []
    },
    maxGroupsInList() {
      return 5
    },
    activeFab() {
      if (!this.flags.started) {
        return {
          id: 0,
          color: 'gradiente',
          icon: 'play_arrow',
          clear: 'play_arrow',
          tooltip: `${this.$t('visor.start_dismissal')}`,
        }
      } else {
        return {
          id: 1,
          color: 'primary',
          icon: 'stop',
          clear: 'stop',
          tooltip: 'Parar salidas',
        }
      }
    },
    searchStudent1() {
      var items = this.transaction.transactions1
      if (this.search == null || this.search.trim() === '') return items
      var transformMap = {
        a: '[aá]',
        e: '[eé]',
        i: '[ií]',
        o: '[oó]',
        u: '[uí]',
        A: '[AÁ]',
        E: '[EÉ]',
        I: '[IÍ]',
        O: '[OÓ]',
        U: '[UÚ]',
      }
      var search = this.search ? this.search : ''
      search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      for (var key in transformMap) {
        search = search.replace(key, transformMap[key])
      }
      var matcher = new RegExp(search, 'i')
      return items.filter((item) => {
        return matcher.test(
          [
            item.student.firstName,
            item.student.lastName,
            item.student.firstName + ' ' + item.student.lastName,
          ].join()
        )
      })
    },
    searchStudent3() {
      var items = this.transaction.transactions3
      if (this.search == null || this.search.trim() === '') return items
      var transformMap = {
        a: '[aá]',
        e: '[eé]',
        i: '[ií]',
        o: '[oó]',
        u: '[uí]',
        A: '[AÁ]',
        E: '[EÉ]',
        I: '[IÍ]',
        O: '[OÓ]',
        U: '[UÚ]',
      }
      var search = this.search ? this.search : ''
      search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      for (var key in transformMap) {
        search = search.replace(key, transformMap[key])
      }
      var matcher = new RegExp(search, 'i')
      return items.filter((item) => {
        return matcher.test(
          [
            item.student.firstName,
            item.student.lastName,
            item.student.firstName + ' ' + item.student.lastName,
          ].join()
        )
      })
    },
    ...mapGetters(['getUser', 'getBranch']),
  },
}
</script>

<style>
.salidas-container .elementVisor .v-list__tile.v-list__tile--avatar {
  height: 100px;
}
.buttonLeft > .v-list__tile--avatar {
  padding-right: 0 !important;
}
.elementVisor {
  border-top-left-radius: 40px !important;
  border-bottom-left-radius: 40px !important;
}
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}
.container.entregas-total-tags {
  max-width: 900px;
  margin: auto !important;
  padding: 20px;
}
.container.entregas-total-tags .v-image {
  border-radius: 50%;
  width: 50px;
  max-width: 50px;
  height: 50px;
  max-height: 50px;
}

.container.entregas-total-tags .v-image p {
  line-height: 50px;
  margin: 0;
  color: white;
}
.container.entregas-total-tags .v-image.total {
  background: #aa1302;
}

.container.entregas-total-tags .interactive {
  cursor: pointer;
}

.container.entregas-total-tags .solicitados.interactive.active p.tag-label {
  border-bottom: 2px solid #0190ff;
}
.container.entregas-total-tags .camino.interactive.active p.tag-label {
  border-bottom: 2px solid #ff8e2c;
}
.container.entregas-total-tags .solicitados .v-image {
  background: #0190ff;
}

.container.entregas-total-tags .camino .v-image {
  background: #ff8e2c;
}

.container.entregas-total-tags .v-image.entrega {
  background: #02aa17;
}

/* .container.entregas-total-tags .v-image.entrega {
style="margin-top: 15px; margin-left: 10px; margin-right: 45px;"
} */
.container.entregas-total-tags .flex.xs4 .tag-label {
  margin: 0;
  margin-left: 10px;
}
.container.entregas-total-tags.is-column .flex.xs4 .tag-label {
  margin-left: 0px;
  margin-top: 15px;
}

.container.entregas-total-tags .flex.xs4 {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.container.entregas-total-tags.is-column .flex.xs4 {
  justify-content: flex-start;
  flex-direction: column;
}
.salidas-container .tags-toolbar {
  background: white;
}
.salidas-container .groups-bar .v-toolbar__content {
  display: block;
  height: auto !important;
  /* line-height: 60px; */
  padding-top: 20px;
  padding-bottom: 20px;
}

.salidas-container .groups-bar .v-toolbar__content .v-tooltip {
  white-space: nowrap;
}
.salidas-container .groups-bar {
  padding-left: 40px !important;
  font-size: 16px;
}

.more-groups-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.salidas-container .tags-toolbar .v-toolbar__content {
  height: auto !important;
}

.salidas-container .v-list--three-line .v-list__tile {
  height: 115px !important;
}
.container.entregas-total-tags.very-small {
  padding-right: 0;
  padding-left: 0;
}
.container.entregas-total-tags.very-small .flex.xs4 {
  font-size: 11px;
}

.container.entregas-total-tags.very-small .flex.xs4 .tag-label {
  margin-top: 5px;
}

.container.entregas-total-tags.very-small .v-image {
  width: 35px;
  max-width: 35px;
  height: 35px;
  max-height: 35px;
}

.container.entregas-total-tags.very-small .v-image p {
  line-height: 35px;
}
</style>
<style scoped>
#startBtn {
  cursor: pointer;
  position: absolute;
  width: 300px;
  margin-left: -150px;
  left: 50%;
  z-index: 3;
  top: 32%;
}

.cls-1 {
  fill: #e7545d;
}
.cls-2 {
  font-size: 42.36px;
  font-family: Roboto-Regular, Roboto;
}
.cls-2,
.cls-3 {
  fill: #fff;
}
</style>
